<svg
	class={$$props.class || ''}
	xmlns="http://www.w3.org/2000/svg"
	x="0px"
	y="0px"
	viewBox="0 0 64 64"
	enable-background="new 0 0 64 64"
	xml:space="preserve"
>
	<circle fill="#FFC400" cx="32" cy="32" r="32" />
	<circle fill="#FC594F" cx="54" cy="10" r="5" />
	<polygon
		fill="#FFFFFF"
		points="21.467,22.101 41.111,22.101 41.111,20.988 20.355,20.988 20.355,40.477 21.467,40.477 "
	/>
	<path
		fill="#FFFFFF"
		d="M22.889,23.523v19.489h20.756V23.523H22.889z M27.881,26.931h10.772c0.35,0,0.634,0.284,0.634,0.634 c0,0.35-0.284,0.634-0.634,0.634H27.881c-0.35,0-0.634-0.284-0.634-0.634C27.248,27.214,27.531,26.931,27.881,26.931z M27.881,30.733h10.772c0.35,0,0.634,0.284,0.634,0.634c0,0.35-0.284,0.634-0.634,0.634H27.881c-0.35,0-0.634-0.284-0.634-0.634 C27.248,31.016,27.531,30.733,27.881,30.733z M27.881,34.535h10.772c0.35,0,0.634,0.284,0.634,0.634 c0,0.35-0.284,0.634-0.634,0.634H27.881c-0.35,0-0.634-0.284-0.634-0.634C27.248,34.818,27.531,34.535,27.881,34.535z M27.881,38.337h10.772c0.35,0,0.634,0.284,0.634,0.634c0,0.35-0.284,0.634-0.634,0.634H27.881c-0.35,0-0.634-0.284-0.634-0.634 C27.248,38.62,27.531,38.337,27.881,38.337z"
	/>
	<path
		fill="#282E35"
		d="M42.533,22.101v-2.535H18.932v22.333h2.535v2.535h23.601V22.101H42.533z M43.645,43.012H22.889V23.523 h20.756V43.012z M20.355,20.988h20.756v1.113H21.467v18.376h-1.113V20.988z"
	/>
	<path
		fill="#282E35"
		d="M27.881,28.198h10.772c0.35,0,0.634-0.284,0.634-0.634c0-0.35-0.284-0.634-0.634-0.634H27.881 c-0.35,0-0.634,0.284-0.634,0.634C27.248,27.914,27.531,28.198,27.881,28.198z"
	/>
	<path
		fill="#282E35"
		d="M27.881,39.604h10.772c0.35,0,0.634-0.284,0.634-0.634c0-0.35-0.284-0.634-0.634-0.634H27.881 c-0.35,0-0.634,0.284-0.634,0.634C27.248,39.32,27.531,39.604,27.881,39.604z"
	/>
	<path
		fill="#282E35"
		d="M27.881,35.802h10.772c0.35,0,0.634-0.284,0.634-0.634c0-0.35-0.284-0.634-0.634-0.634H27.881 c-0.35,0-0.634,0.284-0.634,0.634C27.248,35.518,27.531,35.802,27.881,35.802z"
	/>
	<path
		fill="#282E35"
		d="M27.881,32h10.772c0.35,0,0.634-0.284,0.634-0.634c0-0.35-0.284-0.634-0.634-0.634H27.881 c-0.35,0-0.634,0.284-0.634,0.634C27.248,31.716,27.531,32,27.881,32z"
	/>
</svg>
